var url = window.location.href.toLowerCase();

// Check if URL contains cjevent so we set cookie value
if(url.includes('cjevent') == true ) {
    // Add CJ event tracking
    var cjEventID = getParameterByName("cjevent");
    console.log("CJ event parameter is " + cjEventID);

    // Set CJEvent cookie value
    if(cjEventID != "") {
        createCJCookie('cjevent', cjEventID, 30);
    }
}


// Create the tag to push to CJ 
if(window.location.href.includes('thank_you') == true) {
    var items = '';
    if(Shopify.checkout) {
        
        if(Shopify.checkout.line_items) {
            lineItems = Shopify.checkout.line_items;
            numItems  = lineItems.length;
            for(var i = 0; i < numItems; i++) {
              itemNumber = i + 1;
              items += "&" + "ITEM" + itemNumber + "=" + lineItems[i].sku + 
                    "&" + "AMT" + itemNumber + "=" + lineItems[i].price + 
                    "&" + "QTY" + itemNumber + "=" + lineItems[i].quantity;
            }

            var frm = document.createElement('iframe');
            frm.height='1px';
            frm.width='1px';
            frm.frameborder='0';
            frm.scrolling="no";
            frm.name='cj_conversion';
            var src="https://www.emjcd.com/tags/c?containerTagId=14666&OID=" + Shopify.checkout.order_id + "&CID=1537887&TYPE=386543"; 
            if(Shopify.checkout.currency) {
              src += "&CURRENCY=" + Shopify.checkout.currency;
            } else {
              src += "&CURRENCY=USD";
            }
            if(Shopify.checkout.discount) {
                src += "&DISCOUNT=" + Shopify.checkout.discount.amount;
                src += "&COUPON=" + Shopify.checkout.discount.code;
            }
            if(items) {
                src += items;
            }

            cjEventCookie = readCookie('cjevent');

            console.log("CJ cookie value is " + cjEventCookie);

            if (cjEventCookie) {
                src += "&CJEVENT=" + cjEventCookie;
            }
            //console.log(src);
            frm.src = src;
            document.body.appendChild(frm);
        }
    }
}

function createCJCookie(name, value, days) {
    var date, expires; 
    if(days) {
        date = new Date(); 
        date.setTime(date.getTime() + ( days * 24 * 60 * 60 * 1000)); 
        expires = "; expires="+date.toGMTString(); 
    } else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie, you can pass this function into the tag, i.e. CJEVENT=readCookie('cjevent')
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }
    return null;
}

// Get parameter by name 
function getParameterByName(name) {
    url = window.location.href.toLowerCase();
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}